// extracted by mini-css-extract-plugin
export default {"root":"SelectedPlanButton_root__QYoAZ"};